<template>
    <rkm-overlay>
        <rkm-layout-body title="Histórico do atendimento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/paciente-busca/List'

export default {
    components: { List },
}
</script>